import React from 'react'
import styled from 'styled-components'

import { DashboardContext } from 'live/context/dashboard'
import { getDashboardLinkNavigation } from '../services/api'
import { mountDashboardLink } from '../utils/mountDashboardLink'
import { useSpan } from '../hooks/useSpan'

export const DashboardMenuLinks = (): JSX.Element => {
    const [dashboards, setDashboards] = React.useState([])
    const dashboardContext = React.useContext(DashboardContext)
    const { theme } = dashboardContext

    const { span } = useSpan(dashboardContext)

    React.useEffect(() => {
        if (dashboardContext?.dashboard?.id) {
            getDashboardLinkNavigation(dashboardContext?.dashboard?.id).then(resp => {
                setDashboards(resp)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        dashboards.length > 0 && (
            <LinksContainer isDark={theme === 'dark'}>
                {dashboards.map((dashboard, index) => {
                    return (
                        <LinkItem key={`link-${index + 1}_${dashboard.id}`}>
                            <Link href={mountDashboardLink(dashboard.id, span, dashboardContext?.dashboard)}>
                                <i className="fa fa-chart-bar"></i>
                                <span>{dashboard.title}</span>
                            </Link>
                        </LinkItem>
                    )
                })}
            </LinksContainer>
        )
    )
}

const LinkItem = styled.div`
    background-color: var(--blue-500);
    cursor: pointer;
    width: max-content;
    height: 24px;
    border-radius: 3px;
`
const LinksContainer = styled.div<{ isDark: boolean }>`
    display: flex;
    justify-content: flex-start;
    padding: 12px 16px;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
    background-color: ${({ isDark }) => (isDark ? 'rgb(49,57,71)' : 'var(--gray-300)')};
`
const Link = styled.a`
    display: flex;
    align-items: center;
    padding: 4px 16px;
    gap: 8px;

    i,
    span {
        font-style: normal;
        font-weight: 600;
        font-size: 13px;
        line-height: 16px;
        display: flex;
        align-items: center;
        color: var(--gray-0);
    }
`
